define('views/modules/calendar/animated-session/exercise/weight/history/weight-history-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/animated-session/exercise/weight/history/weight-history-header',
    'views/modules/calendar/animated-session/exercise/weight/history/weight-history-row',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/history/weight-history-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VWeightHistoryHeader,
    VWeightHistoryRow,
    // templates
    TWeightHistoryContent
) {

    var VWeightHistoryContent = Backbone.View.extend({
        template: TWeightHistoryContent,

        regions: {
            table: ".exercise-weight-table",
        },

        initialize: function(opt) {
            this.options = opt || {};
            var model = this.model,
                exercise = this.exercise = opt.exercise;

            this.collection = opt.sets;

            this.view = {
                header: new VWeightHistoryHeader({ model: exercise })
            };
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();

            this.resetList();

            return this;
        },

        addAll: function() {
            var collection = this.collection.sets,
                container = document.createDocumentFragment(),
                chunkSize = 4;

            _.each(collection, function(set) {
                container.appendChild(this.addSet(set, false));
            }, this);

            var tbody = document.createElement('tbody');
            tbody.append(container);
            this.zone.$table.append(tbody);
        },

        addSet: function(set, first, render) {
            var view = new VWeightHistoryRow({
                model: set,
                first: first,
                setIndex: this.collection.sets.indexOf(set) + 1,
            });

            this.childViews.push(view);
            view.render();

            return view.el;
        },

        resetList: function() {
            this.zone.$table.empty().append(this.view.header.render().el);
            this.removeChildViews({ defer: true });
            _.defer(this.addAll.bind(this));
        },

    });

    return VWeightHistoryContent;

});

